import _ from 'underscore';

export const NodeUpdatedHandler = (nodes, node) =>
  nodes.map((n) => {
    if (n.id === node.id) {
      return node;
    }

    if (n.children) {
      return _.extend(n, {
        children: NodeUpdatedHandler(n.children, node),
      });
    }

    return n;
  });
